const HINT_DELAY_MS = 2800
const HINT_DELAY_REDUCED_MS = 1200

function prefersReducedMotion() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

function getHeroSlideIndex(swiper) {
	return Array.from(swiper.slides).findIndex((slide) =>
		slide.classList.contains('fullpage-slide--hero')
	)
}

function isHeroSlideActive(swiper) {
	const heroIndex = getHeroSlideIndex(swiper)
	return heroIndex >= 0 && swiper.activeIndex === heroIndex
}

export function initHeroScrollHint(swiper) {
	const hint = document.querySelector('[data-hero-scroll-hint]')
	if (!hint || !swiper) {
		return
	}

	let showTimer = null
	let dismissed = false

	const clearShowTimer = () => {
		if (showTimer) {
			window.clearTimeout(showTimer)
			showTimer = null
		}
	}

	const hideHint = () => {
		clearShowTimer()
		hint.classList.remove('is-visible')
		hint.setAttribute('aria-hidden', 'true')
	}

	const showHint = () => {
		if (dismissed || !isHeroSlideActive(swiper)) {
			return
		}

		hint.classList.add('is-visible')
		hint.setAttribute('aria-hidden', 'false')
	}

	const scheduleShow = () => {
		hideHint()

		if (dismissed || !isHeroSlideActive(swiper)) {
			return
		}

		const delay = prefersReducedMotion() ? HINT_DELAY_REDUCED_MS : HINT_DELAY_MS
		showTimer = window.setTimeout(showHint, delay)
	}

	const dismissHint = () => {
		dismissed = true
		hideHint()
	}

	swiper.on('slideChange', () => {
		if (isHeroSlideActive(swiper)) {
			scheduleShow()
			return
		}

		dismissHint()
	})

	swiper.on('sliderFirstMove', dismissHint)

	scheduleShow()
}
